<div class="container-fluid">
     <div class="row justify-content-center">
          <div class="col mt-5">
               <!-- Form Error Placeholder -->
               <div class="text-center mb-3">
                    <form-error [form]="form"></form-error>
               </div>

               <!-- Login Button -->
               <div class="text-center">
                    <button (click)="gotoLogin()"
                         class="btn btn-primary btn-lg d-flex align-items-center justify-content-center gap-2"
                         title="Login">
                         <i class="fas fa-sign-in-alt"></i> Proceed to Login
                    </button>
               </div>
          </div>
     </div>
</div>